/* eslint-disable */
import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  ArcElement,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend
);

const ComplaintDisputeBarChart = ({ barData = [0, 0] }) => {
  const barChartData = {
    labels: ['Oppositions'],
    datasets: [
      {
        label: 'Filed by TML',
        data: [barData[0]],
        backgroundColor: '#92a8d1',
        stack: 'stack1',
        barThickness: 30
      },
      {
        label: 'Filed against TML',
        data: [barData[1]],
        backgroundColor: '#2b5797',
        stack: 'stack1',
        maxBarThickness: 30
      },
    ],
  };

  const commonLegend = {
    display: true,
    position: 'bottom',
    labels: {
      usePointStyle: true,
      pointStyle: 'rectRounded',
      color: '#000',
      font: {
        family: 'sans-serif',
        size: 13,
      },
    },
  };

  const barOptions = {
    responsive: true,
    maintainAspectRatio: true,
    aspectRatio: 2.5,
    plugins: {
      legend: commonLegend,
    },
    scales: {
      x: {
        stacked: true,
        ticks: { font: { size: 9 } },
      },
      y: {
        stacked: true,
        beginAtZero: true,
        ticks: {
          stepSize: 1,
          precision: 0,
        },
      },
    },
  };

  return (
    <div
      style={{ width: '100%', maxWidth: '100%', height: '150px'}}
    >
      <Bar data={barChartData} options={barOptions} />
    </div>
  );
};

export default ComplaintDisputeBarChart;

